module.exports = __webpack_public_path__ + "static/fipcmintorganic4-f3a88cd93ccafe353417a77fcb59e845.jpeg";